module.exports = __webpack_public_path__ + "static/media/0016.346da28d.jpg";